import { useMemo } from 'react';

interface UseDomainExtractionProps {
  url: string | undefined;
}

export function useDomainExtraction({ url }: UseDomainExtractionProps) {
  const domain = useMemo(() => {
    if (!url) return '';

    try {
      return new URL(url).hostname.replace('www.', '');
    } catch {
      // Handle invalid URLs gracefully
      return url.split('/')[0] || '';
    }
  }, [url]);

  return domain;
}
